<template>
    <v-overlay
        :model-value="modelValue"
        class="align-center justify-center"
        persistent
    >
        <v-progress-circular indeterminate color="primary" size="64" />
    </v-overlay>
</template>

<script>
export default {
    name: "LoadingOverlay",
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
